import { render, staticRenderFns } from "./SoatView.vue?vue&type=template&id=5590c653&scoped=true"
import script from "./SoatView.vue?vue&type=script&lang=js"
export * from "./SoatView.vue?vue&type=script&lang=js"
import style0 from "./SoatView.vue?vue&type=style&index=0&id=5590c653&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5590c653",
  null
  
)

export default component.exports